import Vue from 'vue'
export const EventBus = new Vue()



// WEBPACK FOOTER //
// ./plugins/eventBus.js